// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Box, Alert } from '@metarouter-private/mr-mui';

export default function UploadResults({ total, succeeded, failed }) {
  const hasFailures = failed > 0;
  const severity = hasFailures ? 'warning' : 'success';
  const message = hasFailures
    ? `Bulk upload complete with ${failed} failure${failed === 1 ? '' : 's'}`
    : 'Bulk upload complete!';

  return (
    <Stack spacing={3}>
      <Alert severity={severity}>
        <Typography variant="body1">{message}</Typography>
      </Alert>
      <Box>
        <Stack direction="row" spacing={3}>
          <Typography variant="body1">
            <strong>Total Files:</strong> {total}
          </Typography>
          <Typography variant="body1" color="success.main">
            <strong>Succeeded:</strong> {succeeded}
          </Typography>
          <Typography variant="body1" color="error.main">
            <strong>Failed:</strong> {failed}
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
}

UploadResults.propTypes = {
  total: PropTypes.number.isRequired,
  succeeded: PropTypes.number.isRequired,
  failed: PropTypes.number.isRequired,
};
